module.exports = __webpack_public_path__ + "img/Auditing-and-accountability-1.1786a179.png";